import { Program, Mesh, Plane, Transform, TextureLoader } from 'ogl'
import anime from 'animejs'

import vertex from '@shaders/default.vert'
import fragment from '@shaders/shrek.frag'

export default class GLShrek {
  constructor ({ gl, parent, sceneVars, meshes }) {
    this.gl = gl
    this.parent = parent
    this.sceneVars = sceneVars
    this.meshes = meshes

    this.isActive = false
    this.lt = Math.random()
    this.ltSpeed = 0.02

    this.animY = -2.75

    this.createMesh()
  }

  createMesh () {
    const texShrek = TextureLoader.load(this.gl, {
      src: './static/textures/shrek-3.jpg',
      wrapS: this.gl.REPEAT,
      wrapT: this.gl.REPEAT,
    })

    const plane = new Plane(this.gl, {
      width: 3.5,
      height: 3.5,
      widthSegments: 1,
      heightSegments: 1,
    })

    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uAspectRatio: { value: 1 },
        uTime: { value: this.lt },
        tMap: { value: texShrek },
      },
    })

    this.mesh = new Mesh(this.gl, { geometry: plane, program: this.program })

    this.wrapper = new Transform(this.gl)

    this.wrapper.position.set(0, this.animY, -3.6)
    this.wrapper.rotation.set(0, 0, 0)

    this.mesh.setParent(this.wrapper)
    this.wrapper.setParent(this.parent)
  }

  moveUp (callback = () => {}) {
    this.isActive = true
    anime({
      targets: this,
      animY: -0.6,
      duration: 7000,
      easing: 'linear',
      complete: () => {
        callback()
      },
    })
  }

  // EVENT HANDLERS
  handleResize () {}

  update (t) {
    if (this.isActive) {
      this.lt += this.ltSpeed

      this.mesh.position.y = -Math.cos(this.lt) * 0.025
      this.wrapper.position.y = this.animY
    }
  }
}
